import type { BoxProps } from '@/components/control/components/box/box.types';
import clsx from 'clsx';
import { forwardRef } from 'react';
import '@/components/control/components/box/box.css';

const Box = forwardRef<HTMLDivElement, BoxProps>(function (props, ref) {
  const { children, className, focused = false, checked = false, state = 'idle', onClick } = props;
  return (
    <div
      ref={ref}
      className={clsx('control-box', className, {
        'control-box--focused': focused,
        'control-box--checked': checked,
        'control-box--idle': state === 'idle',
        'control-box--error': state === 'error',
        'control-box--success': state === 'success',
      })}
      onClick={() => onClick?.call(null)}
    >
      {children}
    </div>
  );
});

export default Box;
